const MetricsConstants = {
	"METRIC_LOAD_PAGE_DATA": "LoadPageData",
	"METRIC_CANCEL_ORDER_REQUEST": "CancelOrderRequest",
}

export default MetricsConstants;